module.exports = __webpack_public_path__ + "static/media/27.67d56aba.jpg";